"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyboardEvents = void 0;
const react_1 = __importDefault(require("react"));
function useKeyboardEvents({ dropdownOptions, onEnter, onSelectCallback, blurInput }) {
    const iconButtonRef = react_1.default.useRef(null);
    const [focusedOptionIdx, setFocusedIdx] = react_1.default.useState(null);
    const [composing, setComposing] = react_1.default.useState(false);
    const handleCompositionStart = () => setComposing(true);
    const handleCompositionEnd = () => setComposing(false);
    const handleKeyDown = react_1.default.useCallback((e) => {
        // composing events happen when users are typing in non-latin characters
        // skip following events when still in composing state
        if (composing) {
            return;
        }
        switch (e.key) {
            case "ArrowDown":
            case "ArrowUp":
                if (!dropdownOptions || dropdownOptions.length === 0) {
                    break;
                }
                e.preventDefault();
                if (focusedOptionIdx === null) {
                    setFocusedIdx(0);
                    break;
                }
                const isArrowingDown = e.key === "ArrowDown";
                const nextIdx = isArrowingDown
                    ? focusedOptionIdx + 1
                    : focusedOptionIdx - 1;
                const lastIdx = dropdownOptions.length - 1;
                if (nextIdx < 0) {
                    setFocusedIdx(lastIdx);
                }
                else if (nextIdx > lastIdx) {
                    setFocusedIdx(0);
                }
                else {
                    setFocusedIdx(nextIdx);
                }
                break;
            case "Enter":
                // If no option is focused, call the onClick function of the icon button
                // This equates to a "submit" action
                if (focusedOptionIdx === null) {
                    if (onEnter) {
                        onEnter();
                    }
                    blurInput();
                    break;
                }
                e.preventDefault();
                const focusedOption = dropdownOptions[focusedOptionIdx];
                if (onSelectCallback && focusedOption) {
                    onSelectCallback(focusedOption);
                }
                setFocusedIdx(null);
                break;
            case "Escape":
                setFocusedIdx(null);
                blurInput();
                break;
            default:
                break;
        }
    }, [
        focusedOptionIdx,
        dropdownOptions,
        onSelectCallback,
        blurInput,
        onEnter,
        composing
    ]);
    return {
        focusedOptionIdx,
        handleKeyDown,
        iconButtonRef,
        handleCompositionStart,
        handleCompositionEnd
    };
}
exports.useKeyboardEvents = useKeyboardEvents;
//# sourceMappingURL=useKeyboardEvents.js.map